import { compact, map } from 'lodash';
import { toUUID } from '../../util/transform';
import type { ITicketSharedWithClientProfile } from './TicketSharedWithClientProfile.interface';
import TicketSharedWithClientProfileSection from './TicketSharedWithClientProfileSection';
import TicketSharedWithClientProfileIntegrations from './TicketSharedWithClientProfileIntegrations';

export default class TicketSharedWithClientProfile implements ITicketSharedWithClientProfile {
  idClient: string;
  wizard: Array<number>;
  sections: Array<TicketSharedWithClientProfileSection>;
  integrations: TicketSharedWithClientProfileIntegrations;
  isExpensesReduced: boolean;
  isFactFindFinished: boolean;

  static build = (data: ITicketSharedWithClientProfile) =>
    new TicketSharedWithClientProfile(data);

  static blank = () => new TicketSharedWithClientProfile();

  /**
   * Constructor
   * @param {TicketSharedWithClientProfile} data
   */
  constructor(data?: ITicketSharedWithClientProfile) {
    this.idClient = toUUID(data?.idClient);
    this.wizard = compact(map(data?.wizard, (w) => parseInt(w, 10)));
    this.sections = map(
      compact(data?.sections),
      (obj) => new TicketSharedWithClientProfileSection(obj)
    );
    this.integrations = new TicketSharedWithClientProfileIntegrations(data?.integrations);
    this.isExpensesReduced = data?.isExpensesReduced === true;
    this.isFactFindFinished = data?.isFactFindFinished === true;
  }
}
